import React, { useEffect } from "react";
import Link from "next/link";
import { useSelector } from "react-redux";

const FooterBottom = () => {
  const headerFooterData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );

  useEffect(() => {
    console.clear();
  }, []);
  return (
    <div className="footer-bottom">
      <p
        dangerouslySetInnerHTML={{
          __html:
            headerFooterData?.site_configuration &&
            headerFooterData?.site_configuration[0]?.copyright_text,
        }}
      ></p>
      <ul className="footer-bottom-right">
        {headerFooterData?.site_configuration &&
          headerFooterData?.site_configuration[0]?.footer_bottom_pages?.map(
            (val, index) => {
              return (
                <li key={index}>
                  <Link href={val?.value?.page?.url} itemProp="link">
                    {val?.value?.page?.title}
                  </Link>
                </li>
              );
            }
          )}
      </ul>
    </div>
  );
};

export default FooterBottom;
